import "core-js/modules/es.symbol.js";
import "core-js/modules/es.symbol.description.js";
import "core-js/modules/es.object.to-string.js";
import "core-js/modules/es.symbol.iterator.js";
import "core-js/modules/es.array.iterator.js";
import "core-js/modules/es.string.iterator.js";
import "core-js/modules/web.dom-collections.iterator.js";
import "core-js/modules/es.array.is-array.js";
import "core-js/modules/es.array.slice.js";
import "core-js/modules/es.function.name.js";
import "core-js/modules/es.array.from.js";
import "core-js/modules/es.regexp.exec.js";
import "core-js/modules/es.string.replace.js";
import "core-js/modules/es.array.filter.js";
import "core-js/modules/es.string.split.js";
import "core-js/modules/es.array.for-each.js";
import "core-js/modules/web.dom-collections.for-each.js";
import "core-js/modules/es.array.map.js";
import "core-js/modules/es.object.assign.js";
import "core-js/modules/es.promise.js";
import "core-js/modules/es.array.index-of.js";
import "core-js/modules/es.array.join.js";
import "core-js/modules/es.array.concat.js";
import "core-js/modules/es.date.to-string.js";
import "core-js/modules/es.regexp.to-string.js";
import "core-js/modules/es.array.includes.js";
import "core-js/modules/es.string.includes.js";
import "core-js/modules/es.array.sort.js";
import "core-js/modules/es.object.get-own-property-descriptor.js";
import _regeneratorRuntime from "/home/vsts/work/1/s/dp-components/node_modules/next/node_modules/@babel/runtime/regenerator";
import _asyncToGenerator from "/home/vsts/work/1/s/dp-components/node_modules/next/node_modules/@babel/runtime/helpers/esm/asyncToGenerator";
import _initializerDefineProperty from "/home/vsts/work/1/s/dp-components/node_modules/next/node_modules/@babel/runtime/helpers/esm/initializerDefineProperty";
import _classCallCheck from "/home/vsts/work/1/s/dp-components/node_modules/next/node_modules/@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "/home/vsts/work/1/s/dp-components/node_modules/next/node_modules/@babel/runtime/helpers/esm/createClass";
import _defineProperty from "/home/vsts/work/1/s/dp-components/node_modules/next/node_modules/@babel/runtime/helpers/esm/defineProperty";
import _applyDecoratedDescriptor from "/home/vsts/work/1/s/dp-components/node_modules/next/node_modules/@babel/runtime/helpers/esm/applyDecoratedDescriptor";

var _class, _descriptor, _descriptor2, _descriptor3, _descriptor4, _descriptor5, _descriptor6, _descriptor7, _descriptor8, _descriptor9, _descriptor10, _descriptor11, _descriptor12, _descriptor13, _descriptor14, _descriptor15, _descriptor16, _descriptor17, _descriptor18, _descriptor19, _descriptor20, _descriptor21, _descriptor22, _descriptor23;

function _createForOfIteratorHelper(o, allowArrayLike) {
  var it;

  if (typeof Symbol === "undefined" || o[Symbol.iterator] == null) {
    if (Array.isArray(o) || (it = _unsupportedIterableToArray(o)) || allowArrayLike && o && typeof o.length === "number") {
      if (it) o = it;
      var i = 0;

      var F = function F() {};

      return {
        s: F,
        n: function n() {
          if (i >= o.length) return {
            done: true
          };
          return {
            done: false,
            value: o[i++]
          };
        },
        e: function e(_e) {
          throw _e;
        },
        f: F
      };
    }

    throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
  }

  var normalCompletion = true,
      didErr = false,
      err;
  return {
    s: function s() {
      it = o[Symbol.iterator]();
    },
    n: function n() {
      var step = it.next();
      normalCompletion = step.done;
      return step;
    },
    e: function e(_e2) {
      didErr = true;
      err = _e2;
    },
    f: function f() {
      try {
        if (!normalCompletion && it["return"] != null) it["return"]();
      } finally {
        if (didErr) throw err;
      }
    }
  };
}

function _unsupportedIterableToArray(o, minLen) {
  if (!o) return;
  if (typeof o === "string") return _arrayLikeToArray(o, minLen);
  var n = Object.prototype.toString.call(o).slice(8, -1);
  if (n === "Object" && o.constructor) n = o.constructor.name;
  if (n === "Map" || n === "Set") return Array.from(o);
  if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen);
}

function _arrayLikeToArray(arr, len) {
  if (len == null || len > arr.length) len = arr.length;

  for (var i = 0, arr2 = new Array(len); i < len; i++) {
    arr2[i] = arr[i];
  }

  return arr2;
}

import { ORDER_TYPE } from "@dp/state";
import { observable, runInAction, computed, makeObservable, action } from "mobx";
import DPServices, { UserTypes } from "@dp/services";
import moment from "moment-timezone";
import { ensureTimeLength, adjustServerTimestamp, PlatformType, getDateInSuperScriptForm, DATE_CONSIDERATIONS, getAdjustedRestaurantLocalTime } from "@dp/common";
import React from "react";
import i18next from "i18next";
var DATE_FORMAT = "MM/DD/YYYY";
var DATE_TIME_FORMAT = "MM/DD/YYYY HH:mm";
var TimeModel = (_class = /*#__PURE__*/function () {
  function TimeModel(platformUtil) {
    var _this = this;

    _classCallCheck(this, TimeModel);

    _initializerDefineProperty(this, "_appAttributes", _descriptor, this);

    _initializerDefineProperty(this, "_capacitySlotsResponse", _descriptor2, this);

    _initializerDefineProperty(this, "_sessionDetails", _descriptor3, this);

    _initializerDefineProperty(this, "_setPickupTimeResponse", _descriptor4, this);

    _initializerDefineProperty(this, "_isTimeModalShown", _descriptor5, this);

    _initializerDefineProperty(this, "_selectedCalendarDate", _descriptor6, this);

    _initializerDefineProperty(this, "_isAsapOptionSelected", _descriptor7, this);

    _initializerDefineProperty(this, "_selectedTimeSlot", _descriptor8, this);

    _initializerDefineProperty(this, "_selectedTimeSlotFromDD", _descriptor9, this);

    _initializerDefineProperty(this, "_errorMessage", _descriptor10, this);

    _initializerDefineProperty(this, "_isCapacityError", _descriptor11, this);

    _initializerDefineProperty(this, "_datePickerRef", _descriptor12, this);

    _initializerDefineProperty(this, "_timePickerRef", _descriptor13, this);

    _initializerDefineProperty(this, "_timeUpdatedModalAcknowledged", _descriptor14, this);

    _initializerDefineProperty(this, "_datePickerIsOpen", _descriptor15, this);

    _initializerDefineProperty(this, "_cartLeadTime", _descriptor16, this);

    _initializerDefineProperty(this, "_recentTimeSelectionFromAPI", _descriptor17, this);

    _defineProperty(this, "platformUtil", void 0);

    _initializerDefineProperty(this, "_currentRequestedDate", _descriptor18, this);

    _initializerDefineProperty(this, "_fetchTimeOrderType", _descriptor19, this);

    _initializerDefineProperty(this, "_orderID", _descriptor20, this);

    _initializerDefineProperty(this, "_localdateTimeSelection", _descriptor21, this);

    _initializerDefineProperty(this, "_isTOGODeliveryCapacityError", _descriptor22, this);

    _initializerDefineProperty(this, "_canCheckoutWithTodaysDate", _descriptor23, this);

    this.platformUtil = platformUtil;
    this._isTimeModalShown = false;
    this._isCapacityError = false;
    this._datePickerRef = /*#__PURE__*/React.createRef();
    this._timePickerRef = /*#__PURE__*/React.createRef();
    this._datePickerIsOpen = false;
    this._isAsapOptionSelected = null;
    runInAction(function () {
      _this._isTOGODeliveryCapacityError = false;
      _this._canCheckoutWithTodaysDate = true;
    });
    makeObservable(this);
  }

  _createClass(TimeModel, [{
    key: "setRecentTimeSelectionFromAPi",
    value: function setRecentTimeSelectionFromAPi(value) {
      var _this2 = this;

      runInAction(function () {
        _this2._recentTimeSelectionFromAPI = value;
      });
    }
  }, {
    key: "setAppAttributes",
    value: function setAppAttributes(_appAttributes) {
      var _this3 = this;

      runInAction(function () {
        _this3._appAttributes = _appAttributes;
      });
    }
  }, {
    key: "setCapacitySlotsResponse",
    value: function setCapacitySlotsResponse(_capacitySlotsResponse) {
      var _this4 = this;

      runInAction(function () {
        _this4._capacitySlotsResponse = _capacitySlotsResponse;
      });
    }
  }, {
    key: "setSessionDetails",
    value: function setSessionDetails(_sessionDetails) {
      var _this5 = this,
          _sessionDetails$order;

      runInAction(function () {
        _this5._sessionDetails = _sessionDetails;
      });

      if (!(_sessionDetails !== null && _sessionDetails !== void 0 && _sessionDetails.asapSelected) && _sessionDetails !== null && _sessionDetails !== void 0 && (_sessionDetails$order = _sessionDetails.orderContext) !== null && _sessionDetails$order !== void 0 && _sessionDetails$order.actualPickupTime) {
        runInAction(function () {
          _this5._isAsapOptionSelected = false;
        });
      }
    }
  }, {
    key: "setPickupTimeResponse",
    value: function setPickupTimeResponse(_setPickupTimeResponse) {
      var _this6 = this;

      runInAction(function () {
        _this6._setPickupTimeResponse = _setPickupTimeResponse;
      });
    }
  }, {
    key: "setCartLeadTime",
    value: function setCartLeadTime(_cartLeadTime, _isCartAsapSelected) {
      var _this7 = this;

      runInAction(function () {
        _this7._cartLeadTime = _cartLeadTime;
      });
    }
  }, {
    key: "setTimeModalShown",
    value: function setTimeModalShown(_isTimeModalShown) {
      var _this8 = this;

      runInAction(function () {
        _this8._isTimeModalShown = _isTimeModalShown;

        if (_isTimeModalShown) {
          if (_this8._isCapacityError) {
            _this8.selectedTimeSlot = _this8.availableSlots[0]; //TODO: get the next available slot, dont default to [0], may be getDPSlot(apitime)
          } else {
            _this8._selectedCalendarDate = null;
            _this8._selectedTimeSlotFromDD = null;
            _this8._isAsapOptionSelected = null;
            _this8._errorMessage = null;
          }
        }
      });
    }
    /**
     * IMPORTANT: availableSlots are always overridden by whatever the times api returns.
     * When user is changing the date from calendar, we want a condition to not show uncommitted
     * values in @computed displayDate and @computed shouldShowAutomaticTimeUpdateMessage
     */

  }, {
    key: "_ensureSlotOrAdvance",

    /**
     * The current pickup Time may become stale as time progresses
     * or if a restaurant is changed and the slot is not available.
     * This will ensure that we advance the slot if pickupTime slot
     * is not available.
     */
    value: function _ensureSlotOrAdvance(time) {
      var nextSlot = this.getNextAvailableDPSlot(time);
      return nextSlot === null || nextSlot === void 0 ? void 0 : nextSlot.startTimeInMs;
    }
    /**
     * If the pickup Time from api (session) doesnt have a slot.
     * This case arises on changing locations or for idle sessions
     * WHEN there is a pickup time already selected by user.
     */

  }, {
    key: "_formatAsapTime",
    value: function _formatAsapTime(todayTime, leadTime) {
      var date;
      if (this.platformUtil.PLATFORM_TYPE === PlatformType.WEB) date = moment(todayTime).format("[Today], MMM Do, ");else date = moment(todayTime).format("[Today], ");
      return getDateInSuperScriptForm(date) + "ASAP (" + leadTime + " min) after checkout";
    }
  }, {
    key: "_getFormattedDate",
    value: function _getFormattedDate(time) {
      var includeTime = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : true;

      var toSuperFilter = function toSuperFilter(sup) {
        var res = sup.replace(/(\d)(st)/i, "$1ˢᵗ");
        res = res.replace(/(\d)(nd)/i, "$1ⁿᵈ");
        res = res.replace(/(\d)(rd)/i, "$1ʳᵈ");
        res = res.replace(/(\d)(th)/i, "$1ᵗʰ");
        return res;
      };

      var today = moment();
      var tomorrow = moment().add(1, "days");
      var date = moment(time);

      if (date.isSame(today, "d")) {
        if (this.platformUtil.PLATFORM_TYPE === PlatformType.WEB) return toSuperFilter(date.format("[Today], MMM Do" + (includeTime ? ", h:mm A" : "")));else return toSuperFilter(date.format("[Today]" + (includeTime ? ", h:mm A" : "")));
      } else if (date.isSame(tomorrow, "d")) {
        if (this.platformUtil.PLATFORM_TYPE === PlatformType.WEB) return toSuperFilter(date.format("[Tomorrow], MMM Do" + (includeTime ? ", h:mm A" : "")));else return toSuperFilter(date.format("[Tomorrow]" + (includeTime ? ", h:mm A" : "")));
      } else {
        if (includeTime) {
          return toSuperFilter(date.format("ddd, MMM Do, h:mm A"));
        } else {
          return toSuperFilter(date.format(DATE_FORMAT));
        }
      }
    }
  }, {
    key: "_getCapSlot",

    /**
     * returns the abosolute time capacity slot. If not found return null
     */
    value: function _getCapSlot(time) {
      var slots = this._sortedSlots;
      var timeSlot = null;

      var _iterator = _createForOfIteratorHelper(slots),
          _step;

      try {
        for (_iterator.s(); !(_step = _iterator.n()).done;) {
          var slot = _step.value;

          if (slot.startTimeInMs <= time && slot.endTimeInMs > time) {
            timeSlot = slot;
            break;
          }
        }
      } catch (err) {
        _iterator.e(err);
      } finally {
        _iterator.f();
      }

      return timeSlot;
    }
    /**
     *    given a time, iterate forward until it finds an available slot.
     *    it will return the next available slot.
     *    input: 11:32
     *    9:00-9:15
     *    .
     *    .
     *    .
     *    11:15-11:30 A
     *    11:30-11:45 U <-x
     *    11:45-12:00 U <-x
     *    12:00-12:15 A <-yes
     *  4:23
     */

  }, {
    key: "getNextAvailableDPSlot",
    value: function getNextAvailableDPSlot(time) {
      var slots = this.availableSlots;
      var availableSlot = null;

      var _iterator2 = _createForOfIteratorHelper(slots),
          _step2;

      try {
        for (_iterator2.s(); !(_step2 = _iterator2.n()).done;) {
          var slot = _step2.value;
          if (time > slot.endTimeInMs) continue;

          if (slot.isAvailable) {
            availableSlot = slot;
            break;
          }
        }
      } catch (err) {
        _iterator2.e(err);
      } finally {
        _iterator2.f();
      }

      return availableSlot;
    }
    /**
     * Return the slot based on time.
     * If the slot is not available return the next available slot.
     * If the next slot is not available return null;
     * @param time
     */

  }, {
    key: "_getDPSlot",
    value: function _getDPSlot(time) {
      var slots = this.availableSlots;
      var timeSlot = null;

      var _iterator3 = _createForOfIteratorHelper(slots),
          _step3;

      try {
        for (_iterator3.s(); !(_step3 = _iterator3.n()).done;) {
          var slot = _step3.value;

          if (time >= (slot === null || slot === void 0 ? void 0 : slot.startTimeInMs) && time < (slot === null || slot === void 0 ? void 0 : slot.endTimeInMs)) {
            timeSlot = slot;
            break;
          }
        }
      } catch (err) {
        _iterator3.e(err);
      } finally {
        _iterator3.f();
      }

      if (timeSlot === null) {
        timeSlot = slots.length > 0 ? slots[0] : null;
        /*for (const i in slots) {
          const slot = slots[i];
          const nextSlot = parseInt(i) < slots.length ? slots[i + 1] : null;
          if (
            nextSlot != null &&
            time > slot.endTimeInMs &&
            time <= nextSlot.startTimeInMs
          ) {
            timeSlot = nextSlot;
            break;
          }
        }*/
      }

      return timeSlot;
    }
  }, {
    key: "_getSlotByStartTimeStr",
    value: function _getSlotByStartTimeStr(startTimeStr) {
      var slots = this.availableSlots;
      var timeSlot = null;

      var _iterator4 = _createForOfIteratorHelper(slots),
          _step4;

      try {
        for (_iterator4.s(); !(_step4 = _iterator4.n()).done;) {
          var slot = _step4.value;

          if (startTimeStr === slot.startTime) {
            timeSlot = slot;
            break;
          }
        }
      } catch (err) {
        _iterator4.e(err);
      } finally {
        _iterator4.f();
      }

      return timeSlot;
    }
  }, {
    key: "onTimeSlotSelection",
    value: function onTimeSlotSelection(startTime) {
      var slot = this._getSlotByStartTimeStr(startTime);

      this._selectedTimeSlotFromDD = slot;
    }
  }, {
    key: "onDatepickerFocus",
    value: function onDatepickerFocus() {
      var _this$datePickerRef,
          _this$datePickerRef$c,
          _this$datePickerRef$c2,
          _this9 = this;

      var className = (_this$datePickerRef = this.datePickerRef) === null || _this$datePickerRef === void 0 ? void 0 : (_this$datePickerRef$c = _this$datePickerRef.current) === null || _this$datePickerRef$c === void 0 ? void 0 : (_this$datePickerRef$c2 = _this$datePickerRef$c.input) === null || _this$datePickerRef$c2 === void 0 ? void 0 : _this$datePickerRef$c2.classList;

      if (className) {
        className.toggle("delivery-date-selected");
      }

      if (this._datePickerIsOpen) {
        runInAction(function () {
          _this9._datePickerIsOpen = false;
        });
      } else {
        runInAction(function () {
          _this9._datePickerIsOpen = true;
        });
      }
    }
  }, {
    key: "onTimeSlotFocus",
    value: function onTimeSlotFocus() {
      var _this$timePickerRef, _this$timePickerRef$c;

      var className = (_this$timePickerRef = this.timePickerRef) === null || _this$timePickerRef === void 0 ? void 0 : (_this$timePickerRef$c = _this$timePickerRef.current) === null || _this$timePickerRef$c === void 0 ? void 0 : _this$timePickerRef$c.classList;

      if (className) {
        className.toggle("delivery-date-wrapper-selected");
      }
    }
  }, {
    key: "_getDeliveryOrderAllowedTimesSlots",

    /**
     * 1. generate Delivery Slots based on api params and interval
     * 2. filter by capacity slots, exclude if overlapping
     * 3. filter by safe slots, include if overlapping
     */
    value: function _getDeliveryOrderAllowedTimesSlots() {
      var timeRanges = [];

      var unAvailableCapSlots = this._sortedSlots.filter(function (slot) {
        return !slot.isAvailable;
      });

      var res = this._capacitySlotsResponse;

      if (res !== null && res !== void 0 && res.requestedDate && res !== null && res !== void 0 && res.restaurantAvailableDate) {
        var restAvailableDate = moment(res === null || res === void 0 ? void 0 : res.restaurantAvailableDate, DATE_FORMAT).toDate();
        var requestedDate = moment(res === null || res === void 0 ? void 0 : res.requestedDate, DATE_FORMAT).toDate();
        var timeParts = res === null || res === void 0 ? void 0 : res.firstTimeSlot.split("#");

        if (restAvailableDate.getTime() > requestedDate.getTime()) {
          //no slots available on requested date
          timeRanges = [];
        } else if (restAvailableDate.getTime() === (requestedDate === null || requestedDate === void 0 ? void 0 : requestedDate.getTime())) {
          //Tomorrow' dates (delivery is enabled for tomorrow)
          var requestedDateStr = moment(requestedDate).format(DATE_FORMAT);
          var startTimeHHmm = moment(requestedDateStr + " " + timeParts[1], DATE_TIME_FORMAT);
          var restCurrentHour = moment(requestedDateStr + " " + (res === null || res === void 0 ? void 0 : res.restCurrenthoursForDeliveryDate) + ":00", DATE_TIME_FORMAT);
          var effectiveStartTime = startTimeHHmm.isAfter(restCurrentHour) ? startTimeHHmm : restCurrentHour;
          timeRanges.push({
            startTime: effectiveStartTime.format("HH:mm"),
            endTime: timeParts[2]
          });
        } else {
          //future dates
          timeRanges.push({
            startTime: timeParts[0],
            endTime: timeParts[2]
          });
        }

        var dpSlots = this.generateDPSlots(timeRanges);
        var dpSafeSlots = this.filterBySafeSlotsForDay(requestedDate, dpSlots);
        return this.filterSlotsIfOverlap(dpSafeSlots, unAvailableCapSlots);
      } else {
        return [];
      }
    }
    /**
     * safeTimeSlot: "10:0:0#15:59:0,16:0:0#23:59:0,"
     */

  }, {
    key: "filterBySafeSlotsForDay",
    value: function filterBySafeSlotsForDay(requestedDate, dpSlots) {
      var _this10 = this;

      var safeTimeSlots = this._capacitySlotsResponse["safeTimeSlot"];

      if (safeTimeSlots) {
        var timeRanges = [];
        var ranges = safeTimeSlots.split(",");
        ranges.forEach(function (range) {
          if (range && range.length > 1) {
            var times = range.split("#");
            var rangeObj = {
              startTime: ensureTimeLength(times[0]),
              endTime: ensureTimeLength(times[1])
            };
            timeRanges.push(rangeObj);
          }
        });

        if (timeRanges.length > 0) {
          var newDPSlots = dpSlots.map(function (slot) {
            slot.isAvailable = false;
            return slot;
          });
          timeRanges.forEach(function (range) {
            var deliveryDateStr = moment(requestedDate).format(DATE_FORMAT);
            var startTimeInMs = moment(deliveryDateStr + " " + range.startTime, DATE_TIME_FORMAT).toDate().getTime();
            var endTimeInMs = moment(deliveryDateStr + " " + range.endTime, DATE_TIME_FORMAT).toDate().getTime();
            var safeSlot = {
              startTime: range.startTime,
              startTimeInMs: startTimeInMs,
              endTime: range.endTime,
              endTimeInMs: endTimeInMs,
              isAvailable: true
            };

            var _iterator5 = _createForOfIteratorHelper(newDPSlots),
                _step5;

            try {
              for (_iterator5.s(); !(_step5 = _iterator5.n()).done;) {
                var dpSlot = _step5.value;

                if (_this10.isTimeWithinSlot(dpSlot.startTimeInMs, safeSlot)) {
                  dpSlot.isAvailable = true;
                }
              }
            } catch (err) {
              _iterator5.e(err);
            } finally {
              _iterator5.f();
            }
          });
          dpSlots = newDPSlots.filter(function (slot) {
            return slot.isAvailable;
          });
        }
      }

      return dpSlots;
    }
    /**
     * 1. generate slots based on dinner and lunch time
     * 2. for today, filter out slots by lead time
     * 3. filter by capacity slots, exclude if overlapping
     */

  }, {
    key: "_getPickupOrderAllowedTimesSlots",
    value: function _getPickupOrderAllowedTimesSlots() {
      var _this$_capacitySlotsR, _this$_capacitySlotsR2, _this$_capacitySlotsR3, _this$_capacitySlotsR4;

      var unAvailableCapSlots = this._sortedSlots.filter(function (slot) {
        return !slot.isAvailable;
      });

      var lunch = (_this$_capacitySlotsR = this._capacitySlotsResponse) === null || _this$_capacitySlotsR === void 0 ? void 0 : (_this$_capacitySlotsR2 = _this$_capacitySlotsR.times) === null || _this$_capacitySlotsR2 === void 0 ? void 0 : _this$_capacitySlotsR2.lunch;
      var dinner = (_this$_capacitySlotsR3 = this._capacitySlotsResponse) === null || _this$_capacitySlotsR3 === void 0 ? void 0 : (_this$_capacitySlotsR4 = _this$_capacitySlotsR3.times) === null || _this$_capacitySlotsR4 === void 0 ? void 0 : _this$_capacitySlotsR4.dinner;
      var allowedTimeRanges = [];

      if (lunch && lunch.startTime) {
        allowedTimeRanges.push({
          startTime: ensureTimeLength(lunch.startTime),
          endTime: ensureTimeLength(lunch.endTime)
        });
      }

      if (dinner && dinner.startTime) {
        allowedTimeRanges.push({
          startTime: ensureTimeLength(dinner.startTime),
          endTime: ensureTimeLength(dinner.endTime)
        });
      }

      var dpSlots = this.generateDPSlots(allowedTimeRanges); // const filteredSlots: CPSlot[] = this.filterByLeadTime(dpSlots);

      return this.filterSlotsIfOverlap(dpSlots, unAvailableCapSlots);
    }
    /**
     * filter out old times based on (restaurantLocalTime + leadTime)
     * Mainly used for catering items.
     private filterByLeadTime(dpSlots: CPSlot[]): CPSlot[] {
      const leadTime =
        this?._capacitySlotsResponse?.successResponse?.leadTime || 0;
      const selectedTime: number = this.selectedCalendarDate.getTime();
      const restaurantLocalTime: number = this.restaurantLocalTime;
      const isCurrentDay: boolean =
        moment(restaurantLocalTime).format("MM/DD") ===
        moment(selectedTime).format("MM/DD");
      if (isCurrentDay) {
        const abosoluteLeadTime: number = isCurrentDay
          ? restaurantLocalTime + leadTime * 60 * 1000
          : selectedTime;
        const filteredSlots: CPSlot[] = [];
        for (const slot of dpSlots) {
          if (slot.startTimeInMs >= abosoluteLeadTime) {
            filteredSlots.push(slot);
          }
        }
        return filteredSlots;
      } else {
        return dpSlots;
      }
    }
    */

  }, {
    key: "generateDPSlots",
    value: function generateDPSlots(dpTimeRanges) {
      var _this$_capacitySlotsR5,
          _this11 = this;

      var intervalInMins = (_this$_capacitySlotsR5 = this._capacitySlotsResponse) === null || _this$_capacitySlotsR5 === void 0 ? void 0 : _this$_capacitySlotsR5.interval;
      var dpSlots = [];

      if (intervalInMins) {
        dpTimeRanges.forEach(function (range) {
          var rangeStartTimeInMs = _this11._getTimeOfSelectedDay(range.startTime, "HH:mm");

          var rangeEndTimeInMs = _this11._getTimeOfSelectedDay(range.endTime, "HH:mm");

          var time = rangeStartTimeInMs;

          while (time <= rangeEndTimeInMs) {
            var _endTimeInMs = time + intervalInMins * 60 * 1000;

            dpSlots.push({
              startTime: moment(time).format("h:mm A"),
              startTimeInMs: time,
              endTime: moment(_endTimeInMs).format("hh:mm A"),
              endTimeInMs: _endTimeInMs,
              isAvailable: true
            });
            time = _endTimeInMs;
          }
        });
      }

      return dpSlots;
    }
    /**
     *
     * @param dpSlots by default isAvailable = true
     * @param filterSlots created from ITimeRange values
     * filter out slots which overlap
     */

  }, {
    key: "filterSlotsIfOverlap",
    value: function filterSlotsIfOverlap(dpSlots, filterSlots) {
      var _iterator6 = _createForOfIteratorHelper(filterSlots),
          _step6;

      try {
        for (_iterator6.s(); !(_step6 = _iterator6.n()).done;) {
          var slot = _step6.value;

          var _iterator7 = _createForOfIteratorHelper(dpSlots),
              _step7;

          try {
            for (_iterator7.s(); !(_step7 = _iterator7.n()).done;) {
              var dpSlot = _step7.value;

              if (this._overlap(dpSlot, slot)) {
                dpSlot.isAvailable = false;
              }
            }
          } catch (err) {
            _iterator7.e(err);
          } finally {
            _iterator7.f();
          }
        }
      } catch (err) {
        _iterator6.e(err);
      } finally {
        _iterator6.f();
      }

      return dpSlots.filter(function (slot) {
        return slot.isAvailable;
      });
    }
    /**
     * Scenarios where dates dont overlap
     *           s1----e1
     *  s2---e2            s2----e2
     */

  }, {
    key: "_overlap",
    value: function _overlap(slot1, slot2) {
      var s1 = slot1.startTimeInMs;
      var e1 = slot1.endTimeInMs;
      var s2 = slot2.startTimeInMs;
      var e2 = slot2.endTimeInMs;
      return !(s2 >= e1 || s1 >= e2);
    }
  }, {
    key: "isTimeWithinSlot",
    value: function isTimeWithinSlot(slotStartTime, safeSlot) {
      var safeStart = safeSlot.startTimeInMs;
      var safeEnd = safeSlot.endTimeInMs;
      return slotStartTime >= safeStart && slotStartTime <= safeEnd;
    }
  }, {
    key: "_getTimeOfSelectedDay",

    /**
     * Determining selected day based on delivery type
     * @param timeStr
     * @param timeFormat
     */
    value: function _getTimeOfSelectedDay(timeStr, timeFormat) {
      var selectedTimeOnLoad = 0;

      if (this.isDeliveryOrder) {
        var _this$_capacitySlotsR6;

        var requestedDate = (_this$_capacitySlotsR6 = this._capacitySlotsResponse) === null || _this$_capacitySlotsR6 === void 0 ? void 0 : _this$_capacitySlotsR6.requestedDate;
        selectedTimeOnLoad = requestedDate === null || requestedDate === void 0 ? void 0 : requestedDate.getTime();
      } else {
        selectedTimeOnLoad = this.restaurantLocalTime;
      } // const _selectedDay = this._localSelectedDate
      //   ? moment(this._localSelectedDate, DATE_FORMAT).toDate()
      //   : this?.selectedCalendarDate;


      var selectedDay = (this === null || this === void 0 ? void 0 : this.selectedCalendarDate) || selectedTimeOnLoad;
      var fullTimeStr = moment(selectedDay).format("".concat(DATE_FORMAT, " ")) + timeStr;
      return moment(fullTimeStr, "".concat(DATE_FORMAT, " ").concat(timeFormat)).toDate().getTime();
    }
  }, {
    key: "_convertToUCPSlots",
    value: function _convertToUCPSlots(slots, isAvailable) {
      var _this12 = this;

      var allSlots = [];
      slots.forEach(function (slot) {
        allSlots.push({
          startTime: slot.startTime,
          //03:00 PM TODO: revisit this
          startTimeInMs: _this12._getTimeOfSelectedDay(slot.startTime, "hh:mm A"),
          endTime: slot.endTime,
          endTimeInMs: _this12._getTimeOfSelectedDay(slot.endTime, "hh:mm A"),
          isAvailable: isAvailable
        });
      });
      return allSlots;
    }
  }, {
    key: "getDatesBetween",
    value: function getDatesBetween(minDate, maxDate, excludeDays) {
      var dates = [];
      var startDate = moment(minDate).startOf("day");
      var endDate = moment(maxDate).startOf("day");
      var now = startDate.clone();
      var excludeDaysMap = {};
      excludeDays.forEach(function (_ed) {
        Object.assign(excludeDaysMap, _defineProperty({}, moment(_ed).format("MM/DD/YYYY"), true));
      });

      while (now.isBefore(endDate)) {
        // Filter Out
        if (!excludeDaysMap[now.format("MM/DD/YYYY")]) {
          dates.push(now.toDate());
        }

        now.add(1, "days");
      }

      console.log("filter out " + excludeDays); //TODO:
      // console.log(dates, "filter out ");

      return dates;
    }
  }, {
    key: "getHolidayList",
    value: function getHolidayList() {
      var holidays = [];

      try {
        var _this$_capacitySlotsR7, _this$_capacitySlotsR8;

        var restaurantHolidays = (_this$_capacitySlotsR7 = this._capacitySlotsResponse) === null || _this$_capacitySlotsR7 === void 0 ? void 0 : _this$_capacitySlotsR7.restaurantHolidays; // Cloud restaurantClosed is combination of ATG closedToday, restaurantClosed

        var restaurantClosed = (_this$_capacitySlotsR8 = this._capacitySlotsResponse) === null || _this$_capacitySlotsR8 === void 0 ? void 0 : _this$_capacitySlotsR8.restaurantClosed;

        if (restaurantClosed || !this.canCheckoutWithTodaysDate) {
          holidays.push(moment().toDate());
        }

        var dates = restaurantHolidays === null || restaurantHolidays === void 0 ? void 0 : restaurantHolidays.split("@");

        if (dates && dates.length > 0) {
          dates.forEach(function (dateStr) {
            holidays.push(moment(dateStr, "DD/MM/YYYY").toDate());
          });
        }
      } catch (e) {
        console.log(e);
      }

      return holidays;
    }
  }, {
    key: "handleInvalidModel",
    value: function handleInvalidModel(appMessages) {
      appMessages.showError("Missing Details", "Please enter all highlighted fields.");
    }
  }, {
    key: "submitErrorHandler",
    value: function submitErrorHandler(appMessages, errObj, token) {
      var _this13 = this;

      var handled = false;
      var parsed = DPServices.Cart.parseErrors(errObj);
      var faults = parsed === null || parsed === void 0 ? void 0 : parsed.faults;
      var unAvailableItems = parsed === null || parsed === void 0 ? void 0 : parsed.unAvailableItems;

      if (faults) {
        var asapFaults = faults.filter(function (fault) {
          return fault.faultCode === "asap_not_available" || fault.faultCode === "asap_not_available_pickup";
        });

        if (asapFaults.length > 0) {
          Promise.all([this.platformUtil.saveInSessionStorage("asapNotAvailableText", asapFaults[0].faultDescription), this.platformUtil.saveInSessionStorage("asapErrorFlag", asapFaults[0].faultCode), this.platformUtil.saveInSessionStorage("errorModal", "#asapEnabled-Errormodal")]).then(function () {
            _this13.platformUtil.redirectToURL("/cart");
          }, function () {
            _this13.platformUtil.redirectToURL("/cart");
          });
          handled = true;
        } else if (faults.length > 0 && faults[0].faultCode === "atg.droplet.DropletException" && faults[0].faultDescription.indexOf("This coupon valid till") > -1) {
          appMessages.showError("Error", faults[0].faultDescription);
          handled = true;
        } else if (unAvailableItems && unAvailableItems.length > 0) {
          var labels = [];
          var htmlText = "";
          var removalCommerceIds = [];
          var errorIds = [];

          if (unAvailableItems && Array.isArray(unAvailableItems) && unAvailableItems.length > 0) {
            unAvailableItems.forEach(function (_i) {
              var itemText = "<p><b>-".concat(_i.displayName, "</b></p>");
              htmlText = htmlText + itemText;
              labels.push(_i.displayName);
              removalCommerceIds.push(_i.id);
            });
          }

          Promise.all([this.platformUtil.saveInSessionStorage("dterrorid_array", errorIds ? errorIds.join(",") : ""), this.platformUtil.saveInSessionStorage("errorModal", "#ordertype-errormodal"), this.platformUtil.saveInSessionStorage("unavailableItems", labels.join(","))]).then( /*#__PURE__*/_asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee2() {
            var error;
            return _regeneratorRuntime.wrap(function _callee2$(_context2) {
              while (1) {
                switch (_context2.prev = _context2.next) {
                  case 0:
                    if (_this13.platformUtil.PLATFORM_TYPE === PlatformType.WEB) {
                      _this13.setTimeModalShown(false);

                      error = {
                        title: "Item(s) Not Available.",
                        message: i18next.t("error.items_not_available_info_checkout", {
                          defaultValue: "Sorry! One or more items in your order are currently unavailable. If you continue, the following item(s) will be removed from your cart."
                        }),
                        additionalMessages: labels,
                        options: {
                          undismissible: true,
                          okBtnText: "Continue",
                          showIconBox: false,
                          isRichText: true,
                          i18ResourceString: "error.items_not_available_info",
                          okBtnOnClick: function () {
                            var _okBtnOnClick = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee() {
                              var _this13$currentTimeSl, _this13$_sessionDetai, _this13$_sessionDetai2;

                              var newSelectedTime, newSelectedTimeDate, orderid, setPickupResponse;
                              return _regeneratorRuntime.wrap(function _callee$(_context) {
                                while (1) {
                                  switch (_context.prev = _context.next) {
                                    case 0:
                                      newSelectedTime = _this13 === null || _this13 === void 0 ? void 0 : (_this13$currentTimeSl = _this13.currentTimeSlot) === null || _this13$currentTimeSl === void 0 ? void 0 : _this13$currentTimeSl.startTimeInMs;
                                      newSelectedTimeDate = newSelectedTime ? moment(newSelectedTime).toDate() : moment().toDate();
                                      orderid = _this13._orderID || ((_this13$_sessionDetai = _this13._sessionDetails) === null || _this13$_sessionDetai === void 0 ? void 0 : (_this13$_sessionDetai2 = _this13$_sessionDetai.orderContext) === null || _this13$_sessionDetai2 === void 0 ? void 0 : _this13$_sessionDetai2.orderId);
                                      _context.next = 5;
                                      return DPServices.Times.setOrderPickupTime(newSelectedTimeDate, orderid, token, newSelectedTime ? false : _this13.isAsapSelected, true);

                                    case 5:
                                      setPickupResponse = _context.sent;

                                      _this13.platformUtil.redirectToURL("/menu");

                                    case 7:
                                    case "end":
                                      return _context.stop();
                                  }
                                }
                              }, _callee);
                            }));

                            function okBtnOnClick() {
                              return _okBtnOnClick.apply(this, arguments);
                            }

                            return okBtnOnClick;
                          }()
                        }
                      };
                      appMessages.showError(error.title, error.message, error.additionalMessages, error.options);
                    }

                  case 1:
                  case "end":
                    return _context2.stop();
                }
              }
            }, _callee2);
          })));
          handled = true;
        }
      }

      return handled;
    }
  }, {
    key: "syncAsapSelectionData",

    /*
      Syncs up the ASAP selection data
    */
    value: function syncAsapSelectionData() {
      var _this$currentTimeSlot;

      if (!(this !== null && this !== void 0 && (_this$currentTimeSlot = this.currentTimeSlot) !== null && _this$currentTimeSlot !== void 0 && _this$currentTimeSlot.startTimeInMs)) return;
      var isAsapCutOffReached = this.isAsapCutOffReached,
          isAsapEnabled = this.isAsapEnabled,
          isAsapOptionSelected = this.isAsapOptionSelected;
      var asapOptionShown = isAsapEnabled && !isAsapCutOffReached;
      var isAsapSelected = (isAsapOptionSelected === null || isAsapOptionSelected) && asapOptionShown;

      if (isAsapSelected) {
        this.isAsapOptionSelected = true;
      } else {
        this.isAsapOptionSelected = false;
      }
    }
  }, {
    key: "resetTimeModel",
    value: function resetTimeModel() {
      var _this14 = this;

      runInAction(function () {
        _this14._selectedTimeSlot = null;
        _this14._selectedCalendarDate = null;
        _this14._isAsapOptionSelected = null; // this._localSelectedDate = null;
        // this._localSelectedTime = null;

        _this14._selectedTimeSlotFromDD = null;
        _this14._isTOGODeliveryCapacityError = false;
        _this14._canCheckoutWithTodaysDate = true;
      });
    }
  }, {
    key: "setOrderID",
    value: function setOrderID(_orderID) {
      var _this15 = this;

      runInAction(function () {
        _this15._orderID = _orderID;
      });
    }
  }, {
    key: "setLocaldateTimeSelection",
    value: function setLocaldateTimeSelection(_dateTime) {
      var _this16 = this;

      runInAction(function () {
        _this16._localdateTimeSelection = _dateTime;
      });
    }
  }, {
    key: "setIsTOGODeliveryCapacityError",
    value: function setIsTOGODeliveryCapacityError(_isTOGODeliveryCapacityError) {
      this._isTOGODeliveryCapacityError = _isTOGODeliveryCapacityError;
    }
  }, {
    key: "setCanCheckoutWithTodaysDate",
    value: function setCanCheckoutWithTodaysDate(_canCheckoutWithTodaysDate) {
      this._canCheckoutWithTodaysDate = _canCheckoutWithTodaysDate;
    }
  }, {
    key: "setFetchTimeOrderTypeData",
    set: function set(value) {
      var _this17 = this;

      runInAction(function () {
        _this17._fetchTimeOrderType = value;
      });
    }
  }, {
    key: "fetchTimeOrderType",
    get: function get() {
      return this._fetchTimeOrderType;
    }
  }, {
    key: "recentTimeSelectionFromAPI",
    get: function get() {
      return this._recentTimeSelectionFromAPI ? this._recentTimeSelectionFromAPI : UserTypes.ERecentTimeSelectionFromAPI.SESSION_DETAILS;
    }
  }, {
    key: "datePickerIsOpen",
    get: function get() {
      return this._datePickerIsOpen;
    },
    set: function set(_datePickerIsOpen) {
      var _this18 = this;

      runInAction(function () {
        _this18._datePickerIsOpen = _datePickerIsOpen;
      });
    }
  }, {
    key: "datePickerRef",
    get: function get() {
      return this._datePickerRef;
    },
    set: function set(_datePickerRef) {
      var _this19 = this;

      runInAction(function () {
        _this19._datePickerRef = _datePickerRef;
      });
    }
  }, {
    key: "timePickerRef",
    get: function get() {
      return this._timePickerRef;
    },
    set: function set(_timePickerRef) {
      var _this20 = this;

      runInAction(function () {
        _this20._timePickerRef = _timePickerRef;
      });
    }
  }, {
    key: "isValid",
    get: function get() {
      return this.currentTimeSlot !== null || this.currentTimeSlot !== undefined;
    }
  }, {
    key: "capacitySlotsResponse",
    get: function get() {
      return this._capacitySlotsResponse;
    }
  }, {
    key: "isTimeModalShown",
    get: function get() {
      return this._isTimeModalShown;
    }
  }, {
    key: "isSelectedDateDayOfPickup",
    get: function get() {
      var _this$currentTimeSlot2;

      var dayOfPickup = moment(this.currentAPIPickupTime).format(DATE_FORMAT);
      var selectedDay = moment((_this$currentTimeSlot2 = this.currentTimeSlot) === null || _this$currentTimeSlot2 === void 0 ? void 0 : _this$currentTimeSlot2.startTimeInMs).format(DATE_FORMAT);
      return dayOfPickup === selectedDay;
    }
    /**
     * Applies for today's timeslots
     * Scenario 1: If previously selected mode is ASAP (API response on initial page load return asapSelected = true)
     *          and it is disabled in checkout page due to calculated leadTime exceeds ASAP cutoff time and it defaults to 'Specific date & time'
     * Scenario 2: If the previously selected mode(from menu page) is 'Specific date/time' and the selected timeslot is being updated with new timeslot
     *           due to the capacity
     */

  }, {
    key: "shouldShowAutomaticTimeUpdateMessage",
    get: function get() {
      var shouldModalShow = null;
      var does_API_time_has_a_valid_slot_today = true;

      if (!this._capacitySlotsResponse && this.isAsapSelectedFromAPI) {
        return false;
      }

      if (this.currentAPITimeSlot && this.isSelectedDateDayOfPickup) {
        does_API_time_has_a_valid_slot_today = this.isTimeWithinSlot(this.currentAPIPickupTime, this.currentAPITimeSlot);
      }

      if (!this.timeUpdatedModalAcknowledged) {
        if (this.isAsapSelectedFromAPI) {
          shouldModalShow = this.isAsapCutOffReached;
        } else {
          shouldModalShow = !does_API_time_has_a_valid_slot_today;
        }
      }

      return this.isTimeModalShown ? false : shouldModalShow; //should only happen through page load
    }
  }, {
    key: "isAsapOptionSelected",
    get: function get() {
      if (this.isFreshSession && this._isAsapOptionSelected === null) return null;

      if (this._isAsapOptionSelected !== null) {
        return this._isAsapOptionSelected;
      } else {
        return this.isAsapSelectedFromAPI;
      }
    },
    set: function set(_isAsapOptionSelected) {
      var _this21 = this;

      runInAction(function () {
        _this21._isAsapOptionSelected = _isAsapOptionSelected;
      });
    }
  }, {
    key: "isAsapSelectedFromAPI",
    get: function get() {
      if (this.recentTimeSelectionFromAPI === UserTypes.ERecentTimeSelectionFromAPI.SESSION_DETAILS || this.recentTimeSelectionFromAPI === UserTypes.ERecentTimeSelectionFromAPI.LOCATION_CONFIRMATION_API) {
        var _this$_sessionDetails;

        return !!((_this$_sessionDetails = this._sessionDetails) !== null && _this$_sessionDetails !== void 0 && _this$_sessionDetails.asapSelected);
      } else if (this.recentTimeSelectionFromAPI === UserTypes.ERecentTimeSelectionFromAPI.SET_PICKUP_TIME_API) {
        var _this$_setPickupTimeR;

        return !!((_this$_setPickupTimeR = this._setPickupTimeResponse) !== null && _this$_setPickupTimeR !== void 0 && _this$_setPickupTimeR.asapSelected);
      } else {
        var _this$_capacitySlotsR9;

        return !!((_this$_capacitySlotsR9 = this._capacitySlotsResponse) !== null && _this$_capacitySlotsR9 !== void 0 && _this$_capacitySlotsR9.asapSelected);
      }
    }
  }, {
    key: "isAsapSelected",
    get: function get() {
      return this.isAsapOptionSelected;
    }
  }, {
    key: "needMoreCookTime",
    get: function get() {
      var _this$_setPickupTimeR2;

      return (_this$_setPickupTimeR2 = this._setPickupTimeResponse) === null || _this$_setPickupTimeR2 === void 0 ? void 0 : _this$_setPickupTimeR2.moreCookTimeFlag;
    }
  }, {
    key: "selectedCalendarDate",
    get: function get() {
      if (this._selectedCalendarDate) {
        return this._selectedCalendarDate;
      } else {
        //const time: number = this.currentAPIPickupTime;
        var time = this.currentAPIPickupTime || this._currentRequestedDate;
        console.log("*** selectedCalendarDate ".concat(time));
        return moment(time).startOf("day").toDate();
      }
    },
    set: function set(_selectedCalendarDate) {
      var _this22 = this;

      runInAction(function () {
        _this22._selectedCalendarDate = _selectedCalendarDate;
      });
    }
  }, {
    key: "currentRequestedDate",
    set: function set(_currentRequestedDate) {
      var _this23 = this;

      runInAction(function () {
        _this23._currentRequestedDate = _currentRequestedDate;
      });
    }
  }, {
    key: "areSlotsAvailable",
    get: function get() {
      return this.availableSlots.length > 0;
    }
    /** Take care of determining selected time slot
     *  1. on page Load ensure that a timeslot is present based on actualPickupTime
     *  2. after set pickupTimeAPI
     * */

  }, {
    key: "currentTimeSlot",
    get: function get() {
      console.log("*** currentTimeSlot ".concat(this._selectedTimeSlotFromDD));

      if (this._selectedTimeSlotFromDD) {
        //From the dropdown
        return this._selectedTimeSlotFromDD;
      } else {
        return this.currentAPITimeSlot;
      }
    }
    /**
     * Returns the slot of the server time on the pickup/delivery.
     * If not available, returns the first available slot
     * (due to how _getDPSlot is coded).
     */

  }, {
    key: "currentAPITimeSlot",
    get: function get() {
      var _this$_setPickupTimeR3;

      var time = 0;

      if (this.recentTimeSelectionFromAPI === UserTypes.ERecentTimeSelectionFromAPI.LOCATION_CONFIRMATION_API) {
        time = this.selectedTimeOnPageLoad;
      } else if ((_this$_setPickupTimeR3 = this._setPickupTimeResponse) !== null && _this$_setPickupTimeR3 !== void 0 && _this$_setPickupTimeR3.actualPickupDateTime) {
        var _this$_setPickupTimeR4;

        time = moment((_this$_setPickupTimeR4 = this._setPickupTimeResponse) === null || _this$_setPickupTimeR4 === void 0 ? void 0 : _this$_setPickupTimeR4.actualPickupDateTime, DATE_CONSIDERATIONS.DATE_TIME_FORMAT_WITH_TIME).valueOf();
      } else {
        time = this.selectedTimeOnPageLoad;
      }

      console.log("*** currentAPITimeSlot ".concat(time));
      console.log("*** currentAPITimeSlot time ".concat(time, " ").concat(this._getDPSlot(time)));
      return this._getDPSlot(time);
    }
  }, {
    key: "restaurantLocalTime",
    get: function get() {
      var _this$_capacitySlotsR10, _this$_capacitySlotsR11;

      var time = (_this$_capacitySlotsR10 = this._capacitySlotsResponse) === null || _this$_capacitySlotsR10 === void 0 ? void 0 : (_this$_capacitySlotsR11 = _this$_capacitySlotsR10.currentTime) === null || _this$_capacitySlotsR11 === void 0 ? void 0 : _this$_capacitySlotsR11.time;
      return adjustServerTimestamp(time);
    }
  }, {
    key: "selectedTimeSlot",
    get: function get() {
      if (!this._selectedTimeSlot) {
        return this.currentTimeSlot;
      } else {
        return this._selectedTimeSlot;
      }
    },
    set: function set(_selectedTimeSlot) {
      var _this24 = this;

      runInAction(function () {
        _this24._selectedTimeSlot = _selectedTimeSlot;
      });
    }
  }, {
    key: "selectedTimeSlotFromDD",
    get: function get() {
      if (!this._selectedTimeSlotFromDD) {
        return this.currentTimeSlot;
      } else {
        return this._selectedTimeSlotFromDD;
      }
    },
    set: function set(_selectedTimeSlotFromDD) {
      var _this25 = this;

      runInAction(function () {
        _this25._selectedTimeSlotFromDD = _selectedTimeSlotFromDD;
      });
    }
  }, {
    key: "errorMessage",
    get: function get() {
      return this._errorMessage;
    },
    set: function set(_errorMessage) {
      var _this26 = this;

      runInAction(function () {
        _this26._errorMessage = _errorMessage;
      });
    }
  }, {
    key: "selectedTimeOnPageLoad",
    get: function get() {
      var time = 0;

      if (this.isDeliveryOrder) {
        var _this$_sessionDetails2, _this$_sessionDetails3, _this$_sessionDetails4, _this$_sessionDetails5;

        time = (_this$_sessionDetails2 = this._sessionDetails) === null || _this$_sessionDetails2 === void 0 ? void 0 : (_this$_sessionDetails3 = _this$_sessionDetails2.deliveryGroup) === null || _this$_sessionDetails3 === void 0 ? void 0 : (_this$_sessionDetails4 = _this$_sessionDetails3.deliveryServiceDateTime) === null || _this$_sessionDetails4 === void 0 ? void 0 : (_this$_sessionDetails5 = _this$_sessionDetails4.actualDeliveryDateTime) === null || _this$_sessionDetails5 === void 0 ? void 0 : _this$_sessionDetails5.valueOf();
      } else {
        var _this$_sessionDetails6, _this$_sessionDetails7, _this$_sessionDetails8;

        if (this.validPickupTime) time = (_this$_sessionDetails6 = this._sessionDetails) === null || _this$_sessionDetails6 === void 0 ? void 0 : (_this$_sessionDetails7 = _this$_sessionDetails6.orderContext) === null || _this$_sessionDetails7 === void 0 ? void 0 : (_this$_sessionDetails8 = _this$_sessionDetails7.actualPickupDateTime) === null || _this$_sessionDetails8 === void 0 ? void 0 : _this$_sessionDetails8.valueOf();else time = undefined; // can't set null here, as moment(null) returns Invalid Date
      }

      console.log("*** selectedTimeOnPageLoad ".concat(time));
      return time;
    }
  }, {
    key: "isCapacityError",
    get: function get() {
      return this._isCapacityError;
    },
    set: function set(_isCapacityError) {
      var _this27 = this;

      runInAction(function () {
        _this27._isCapacityError = _isCapacityError;
      });
    }
  }, {
    key: "timeUpdatedModalAcknowledged",
    get: function get() {
      return this._timeUpdatedModalAcknowledged;
    },
    set: function set(_timeUpdatedModalAcknowledged) {
      var _this28 = this;

      runInAction(function () {
        _this28._timeUpdatedModalAcknowledged = _timeUpdatedModalAcknowledged;
      });
    }
  }, {
    key: "currentAPIPickupTime",
    get: function get() {
      var _this$_setPickupTimeR5, _this$_sessionDetails9, _this$_sessionDetails10, _time$toString;

      var time = this.recentTimeSelectionFromAPI === UserTypes.ERecentTimeSelectionFromAPI.LOCATION_CONFIRMATION_API ? this.selectedTimeOnPageLoad : ((_this$_setPickupTimeR5 = this._setPickupTimeResponse) === null || _this$_setPickupTimeR5 === void 0 ? void 0 : _this$_setPickupTimeR5.actualPickupDateTime) || this.selectedTimeOnPageLoad;
      console.log("*** currentAPIPickupTime ".concat(this.selectedTimeOnPageLoad, " ").concat(time, " ").concat(this._currentRequestedDate));

      if (!this._orderID && !((_this$_sessionDetails9 = this._sessionDetails) !== null && _this$_sessionDetails9 !== void 0 && (_this$_sessionDetails10 = _this$_sessionDetails9.orderContext) !== null && _this$_sessionDetails10 !== void 0 && _this$_sessionDetails10.orderId) && this.localdateTimeSelection) {
        return moment(this.localdateTimeSelection).valueOf();
      }

      if (!time && this._currentRequestedDate) return this._currentRequestedDate;else if (time !== null && time !== void 0 && (_time$toString = time.toString()) !== null && _time$toString !== void 0 && _time$toString.includes("/")) return moment(time, DATE_CONSIDERATIONS.DATE_TIME_FORMAT_WITH_TIME).valueOf();else return moment(time).valueOf();
    }
    /**
     * 1. display time from session details
     * 2. if asap is selected, show Asap(x) mins after checkout
     */

  }, {
    key: "displayDate",
    get: function get() {
      var time = this.currentAPIPickupTime;

      if (this.isRestaurantClosedToday) {
        return "Restaurant Closed Today";
      } else if (this.availableSlots.length === 0) {
        return "No Slots Available";
      } else {
        var _this$_sessionDetails11, _this$_sessionDetails12; // if there is no selected time in Session (no orderContext) show local selected time


        if (!this._orderID && !((_this$_sessionDetails11 = this._sessionDetails) !== null && _this$_sessionDetails11 !== void 0 && (_this$_sessionDetails12 = _this$_sessionDetails11.orderContext) !== null && _this$_sessionDetails12 !== void 0 && _this$_sessionDetails12.orderId)) {
          var _this$currentAPITimeS;

          return this.isAsapSelected ? this._formatAsapTime(time, this._effectiveLeadTime) : this._getFormattedDate(this.localdateTimeSelection // APP: show selected local time or default to first valid slot.
          ? time : (_this$currentAPITimeS = this.currentAPITimeSlot) === null || _this$currentAPITimeS === void 0 ? void 0 : _this$currentAPITimeS.startTimeInMs);
        }

        if (this.isAsapSelectedFromAPI) {
          if (this.isAsapCutOffReached) {
            var nextSlot = this.getNextAvailableDPSlot(time);
            return nextSlot ? this._getFormattedDate(nextSlot === null || nextSlot === void 0 ? void 0 : nextSlot.startTimeInMs) : null;
          } else {
            return this._formatAsapTime(time, this._effectiveLeadTime);
          }
        } else if (time) {
          if (this.isSelectedDateDayOfPickup) {
            var _this$currentAPITimeS2;

            time = (_this$currentAPITimeS2 = this.currentAPITimeSlot) === null || _this$currentAPITimeS2 === void 0 ? void 0 : _this$currentAPITimeS2.startTimeInMs;
          }

          if (!this.doesApiPickupTimeHasSlot) {
            console.log("*** before _ensureSlotOrAdvance ".concat(time));
            time = this._ensureSlotOrAdvance(time);
          }

          console.log("*** after _ensureSlotOrAdvance ".concat(time));
          return this._getFormattedDate(time);
        } else {
          return "-";
        }
      }
    }
  }, {
    key: "doesApiPickupTimeHasSlot",
    get: function get() {
      var _this$availableSlots, _this$availableSlots$;

      var time = this.currentAPIPickupTime;
      var pickUpTimeHasAValidSlot = ((_this$availableSlots = this.availableSlots) === null || _this$availableSlots === void 0 ? void 0 : (_this$availableSlots$ = _this$availableSlots.filter(function (_a) {
        return time >= _a.startTimeInMs && time < _a.endTimeInMs;
      })) === null || _this$availableSlots$ === void 0 ? void 0 : _this$availableSlots$.length) === 1;
      return this.isFreshSession || this.isAsapSelected ? true : pickUpTimeHasAValidSlot;
    }
  }, {
    key: "isASAPSelected",
    get: function get() {
      return this.isAsapSelectedFromAPI && !this.isAsapCutOffReached;
    }
  }, {
    key: "asapTextForModalOption",
    get: function get() {
      return "ASAP (" + this._effectiveLeadTime + " min) after checkout";
    }
  }, {
    key: "calendarDisplayDate",
    get: function get() {
      var _this$selectedCalenda;

      return this._getFormattedDate((_this$selectedCalenda = this.selectedCalendarDate) === null || _this$selectedCalenda === void 0 ? void 0 : _this$selectedCalenda.getTime(), false);
    }
  }, {
    key: "isAsapCutOffReached",
    get: function get() {
      var _this$_capacitySlotsR12;

      var cutOffTime = ((_this$_capacitySlotsR12 = this._capacitySlotsResponse) === null || _this$_capacitySlotsR12 === void 0 ? void 0 : _this$_capacitySlotsR12.asapCutoffTime) || 0; //asapCutOffTime will not be present for future dates in times call response.

      var leadTime = this._effectiveLeadTime;
      var isCutOffReached = false;

      if (leadTime === -1 || leadTime > cutOffTime) {
        isCutOffReached = true;
      }

      return isCutOffReached;
    }
  }, {
    key: "asapCutoffTime",
    get: function get() {
      var _this$_capacitySlotsR13;

      return ((_this$_capacitySlotsR13 = this._capacitySlotsResponse) === null || _this$_capacitySlotsR13 === void 0 ? void 0 : _this$_capacitySlotsR13.asapCutoffTime) || 0;
    }
    /**
     * if the "leadTimeSlot" i.e, slot at (currentTime + leadTime) is available return leadTime,
     * else, check if
     */

  }, {
    key: "_effectiveLeadTime",
    get: function get() {
      var _this$_leadTimeCapSlo;

      var leadTime = this._apiLeadTime;
      var newLeadTime = -1;

      if ((_this$_leadTimeCapSlo = this._leadTimeCapSlot) !== null && _this$_leadTimeCapSlo !== void 0 && _this$_leadTimeCapSlo.isAvailable) {
        return leadTime;
      } else {
        var currentTime = this.restaurantLocalTime;
        var abosoluteLeadTime = currentTime + leadTime * 60 * 1000;
        var nextAvailableSlot = this.getNextAvailableDPSlot(abosoluteLeadTime);

        if (nextAvailableSlot) {
          var diff = (nextAvailableSlot === null || nextAvailableSlot === void 0 ? void 0 : nextAvailableSlot.startTimeInMs) - currentTime;
          newLeadTime = diff / 60000;
        }

        return newLeadTime;
      }
    }
  }, {
    key: "_apiLeadTime",
    get: function get() {
      var _this$_capacitySlotsR14;

      return this._cartLeadTime || ((_this$_capacitySlotsR14 = this._capacitySlotsResponse) === null || _this$_capacitySlotsR14 === void 0 ? void 0 : _this$_capacitySlotsR14.leadTime);
    }
  }, {
    key: "_leadTimeCapSlot",
    get: function get() {
      var _this$_capacitySlotsR15;

      var leadTime = (_this$_capacitySlotsR15 = this._capacitySlotsResponse) === null || _this$_capacitySlotsR15 === void 0 ? void 0 : _this$_capacitySlotsR15.leadTime;
      var currentTime = this.restaurantLocalTime;
      var abosoluteLeadTime = currentTime + leadTime * 60 * 1000;
      return this._getCapSlot(abosoluteLeadTime);
    }
  }, {
    key: "selectedCalendarTime",
    get: function get() {
      if (this._selectedTimeSlot === null) {
        return moment(this.currentAPIPickupTime).toDate();
      } else {
        var _this$_selectedTimeSl;

        var startTimeStr = (_this$_selectedTimeSl = this._selectedTimeSlot) === null || _this$_selectedTimeSl === void 0 ? void 0 : _this$_selectedTimeSl.startTime; //03:00 PM

        var calTime = this._selectedCalendarDate;
        var newStringDate = moment(calTime).format(DATE_FORMAT) + " " + startTimeStr;
        return moment(newStringDate).toDate();
      }
    }
  }, {
    key: "isRestaurantClosedToday",
    get: function get() {
      var _this$_capacitySlotsR16, _this$_capacitySlotsR17, _this$_capacitySlotsR18, _this$_capacitySlotsR19, _this$_capacitySlotsR20;

      return ((_this$_capacitySlotsR16 = this._capacitySlotsResponse) === null || _this$_capacitySlotsR16 === void 0 ? void 0 : _this$_capacitySlotsR16.restaurantClosed) || ((_this$_capacitySlotsR17 = this._capacitySlotsResponse) === null || _this$_capacitySlotsR17 === void 0 ? void 0 : (_this$_capacitySlotsR18 = _this$_capacitySlotsR17.times) === null || _this$_capacitySlotsR18 === void 0 ? void 0 : _this$_capacitySlotsR18.lunch) === false && ((_this$_capacitySlotsR19 = this._capacitySlotsResponse) === null || _this$_capacitySlotsR19 === void 0 ? void 0 : (_this$_capacitySlotsR20 = _this$_capacitySlotsR19.times) === null || _this$_capacitySlotsR20 === void 0 ? void 0 : _this$_capacitySlotsR20.dinner) === false;
    }
  }, {
    key: "isAsapEnabled",
    get: function get() {
      var _this$availableSlots2;

      return this.isASapEnabledAPI && !this.isRestaurantClosedToday && !!((_this$availableSlots2 = this.availableSlots) !== null && _this$availableSlots2 !== void 0 && _this$availableSlots2.length);
    }
  }, {
    key: "isASapEnabledAPI",
    get: function get() {
      if (this.recentTimeSelectionFromAPI === UserTypes.ERecentTimeSelectionFromAPI.SESSION_DETAILS || this.recentTimeSelectionFromAPI === UserTypes.ERecentTimeSelectionFromAPI.LOCATION_CONFIRMATION_API) {
        var _this$_sessionDetails13;

        return !!((_this$_sessionDetails13 = this._sessionDetails) !== null && _this$_sessionDetails13 !== void 0 && _this$_sessionDetails13.asapEnabled);
      } else if (this.recentTimeSelectionFromAPI === UserTypes.ERecentTimeSelectionFromAPI.SET_PICKUP_TIME_API) {
        var _this$_setPickupTimeR6;

        return !!((_this$_setPickupTimeR6 = this._setPickupTimeResponse) !== null && _this$_setPickupTimeR6 !== void 0 && _this$_setPickupTimeR6.asapEnabled);
      } else {
        var _this$_capacitySlotsR21;

        return !!((_this$_capacitySlotsR21 = this._capacitySlotsResponse) !== null && _this$_capacitySlotsR21 !== void 0 && _this$_capacitySlotsR21.asapEnabled);
      }
    }
    /**
     * generate time slots of {_capacitySlotsResponse.interval}
     * only generate for lunch and dinner hours
     * Remove capacity unavailable slots.
     * eg, DP 11 am to 12 pm lunch hour with interval of 10 mins,
     * on Dash capacity for 11:30 to 11:45 is unavailable
     * [11:00],[11:10-],[11:20]..[11:50]
     *
     */

  }, {
    key: "availableSlots",
    get: function get() {
      var allowedTimeSlots = [];

      if (this.isRestaurantClosedToday) {
        return [];
      }

      if ( // this.isDeliveryOrder &&
      this.fetchTimeOrderType === ORDER_TYPE.CATERING_DELIVERY) {
        allowedTimeSlots = this._getDeliveryOrderAllowedTimesSlots();
      } else {
        allowedTimeSlots = this._getPickupOrderAllowedTimesSlots();
      }

      return allowedTimeSlots;
    }
  }, {
    key: "_sortedSlots",
    get: function get() {
      var _this$_capacitySlotsR22;

      var capacitySlots = (_this$_capacitySlotsR22 = this._capacitySlotsResponse) === null || _this$_capacitySlotsR22 === void 0 ? void 0 : _this$_capacitySlotsR22.capacitySlots;
      var allSlots = [];

      if (capacitySlots) {
        if (capacitySlots.availableSlots) {
          allSlots = allSlots.concat(this._convertToUCPSlots(capacitySlots.availableSlots, true));
        }

        if (capacitySlots.unavailableSlots) {
          allSlots = allSlots.concat(this._convertToUCPSlots(capacitySlots.unavailableSlots, false));
        }
      }

      return allSlots.sort(function (a, b) {
        return a.startTimeInMs - b.startTimeInMs;
      });
    }
  }, {
    key: "isDeliveryOrder",
    get: function get() {
      var _this$_sessionDetails14, _this$_sessionDetails15, _this$_sessionDetails16, _this$_sessionDetails17;

      return ((_this$_sessionDetails14 = this._sessionDetails) === null || _this$_sessionDetails14 === void 0 ? void 0 : (_this$_sessionDetails15 = _this$_sessionDetails14.orderContext) === null || _this$_sessionDetails15 === void 0 ? void 0 : _this$_sessionDetails15.orderTypeValue) === 2 || ((_this$_sessionDetails16 = this._sessionDetails) === null || _this$_sessionDetails16 === void 0 ? void 0 : (_this$_sessionDetails17 = _this$_sessionDetails16.orderContext) === null || _this$_sessionDetails17 === void 0 ? void 0 : _this$_sessionDetails17.orderTypeValue) === 6;
    }
  }, {
    key: "isDineInOrder",
    get: function get() {
      var _this$_sessionDetails18, _this$_sessionDetails19;

      return ((_this$_sessionDetails18 = this._sessionDetails) === null || _this$_sessionDetails18 === void 0 ? void 0 : (_this$_sessionDetails19 = _this$_sessionDetails18.orderContext) === null || _this$_sessionDetails19 === void 0 ? void 0 : _this$_sessionDetails19.orderTypeValue) === 5;
    }
    /**
     * get future dates from appAttributes based on order type.
     * If restaurant is closing before, honor that value.
     */

  }, {
    key: "maxFutureDate",
    get: function get() {
      var _this$_capacitySlotsR23;

      var maxFutureDays = null;

      if (this.isDeliveryOrder) {
        var _this$_appAttributes;

        maxFutureDays = (_this$_appAttributes = this._appAttributes) === null || _this$_appAttributes === void 0 ? void 0 : _this$_appAttributes["cateringDeliveryFutureDaysThreshold"];
      } else {
        var _this$_appAttributes2;

        maxFutureDays = (_this$_appAttributes2 = this._appAttributes) === null || _this$_appAttributes2 === void 0 ? void 0 : _this$_appAttributes2.futureDaysThreshold;
      }

      maxFutureDays = maxFutureDays || 30;

      if ((_this$_capacitySlotsR23 = this._capacitySlotsResponse) !== null && _this$_capacitySlotsR23 !== void 0 && _this$_capacitySlotsR23.restPermClosedDate) {
        var _this$_capacitySlotsR24;

        var restClosesInDays = Math.abs(moment((_this$_capacitySlotsR24 = this._capacitySlotsResponse) === null || _this$_capacitySlotsR24 === void 0 ? void 0 : _this$_capacitySlotsR24.restPermClosedDate).diff(moment().toDate(), "day"));
        maxFutureDays = maxFutureDays < restClosesInDays ? maxFutureDays : restClosesInDays;
      }

      var maxFutureDate = moment().add(maxFutureDays, "days");
      return maxFutureDate.toDate();
    }
  }, {
    key: "calendarConfig",
    get: function get() {
      var today = moment(this.restaurantLocalTime);
      var tomorrow = moment(this.restaurantLocalTime).add(1, "days");
      var minDate = this.isDeliveryOrder ? tomorrow : today;
      return {
        minDate: minDate === null || minDate === void 0 ? void 0 : minDate.toDate(),
        maxDate: this === null || this === void 0 ? void 0 : this.maxFutureDate,
        excludeDates: this.getHolidayList() || []
      };
    }
  }, {
    key: "calendarDates",
    get: function get() {
      var config = this.calendarConfig;
      return this.getDatesBetween(config.minDate, config.maxDate, config.excludeDates);
    }
  }, {
    key: "isSelectedTimeSlotValid",
    get: function get() {
      var _this$currentTimeSlot3, _this$availableSlots3;

      return !!((_this$currentTimeSlot3 = this.currentTimeSlot) !== null && _this$currentTimeSlot3 !== void 0 && _this$currentTimeSlot3.startTimeInMs) && !!((_this$availableSlots3 = this.availableSlots) !== null && _this$availableSlots3 !== void 0 && _this$availableSlots3.length);
    }
  }, {
    key: "firstAvailableSlot",
    get: function get() {
      if (this.availableSlots && this.availableSlots.length) {
        return this.availableSlots[0];
      } else return null;
    }
  }, {
    key: "isFreshSession",
    get: function get() {
      var _this$_sessionDetails20, _this$_sessionDetails21;

      if ((_this$_sessionDetails20 = this._sessionDetails) !== null && _this$_sessionDetails20 !== void 0 && (_this$_sessionDetails21 = _this$_sessionDetails20.orderContext) !== null && _this$_sessionDetails21 !== void 0 && _this$_sessionDetails21.actualPickupTime || this._setPickupTimeResponse) {
        return false;
      } else return true;
    } //Better handle this IncompleteOrder Id scenario with Location confirmation on edit/remove flow

  }, {
    key: "doesCartHaveItemWithNoPickupTime",
    get: function get() {
      var _this$_sessionDetails22, _this$_sessionDetails23, _this$_setPickupTimeR7;

      return ((_this$_sessionDetails22 = this._sessionDetails) === null || _this$_sessionDetails22 === void 0 ? void 0 : (_this$_sessionDetails23 = _this$_sessionDetails22.orderContext) === null || _this$_sessionDetails23 === void 0 ? void 0 : _this$_sessionDetails23.itemCount) > 0 && !((_this$_setPickupTimeR7 = this._setPickupTimeResponse) !== null && _this$_setPickupTimeR7 !== void 0 && _this$_setPickupTimeR7.actualPickupDateTime || this.selectedTimeOnPageLoad);
    }
  }, {
    key: "restaurantHolidays",
    get: function get() {
      var _this$_capacitySlotsR25;

      return (_this$_capacitySlotsR25 = this._capacitySlotsResponse) === null || _this$_capacitySlotsR25 === void 0 ? void 0 : _this$_capacitySlotsR25.restaurantHolidays;
    }
  }, {
    key: "isValidDeliveryDate",
    get: function get() {
      var _this$_sessionDetails24, _this$_sessionDetails25;

      var sessionDetailsRestObj = (_this$_sessionDetails24 = this._sessionDetails) === null || _this$_sessionDetails24 === void 0 ? void 0 : _this$_sessionDetails24.restaurantDetails;
      var restLocalDateTime = getAdjustedRestaurantLocalTime(sessionDetailsRestObj === null || sessionDetailsRestObj === void 0 ? void 0 : sessionDetailsRestObj.timeZone, sessionDetailsRestObj === null || sessionDetailsRestObj === void 0 ? void 0 : sessionDetailsRestObj.dayLightSavingTime);

      if ((_this$_sessionDetails25 = this._sessionDetails) !== null && _this$_sessionDetails25 !== void 0 && _this$_sessionDetails25.deliveryGroup) {
        var _this$_sessionDetails26, _this$_sessionDetails27, _this$_sessionDetails28, _this$_sessionDetails29, _this$_sessionDetails30;

        if (moment((_this$_sessionDetails26 = this._sessionDetails) === null || _this$_sessionDetails26 === void 0 ? void 0 : (_this$_sessionDetails27 = _this$_sessionDetails26.deliveryGroup) === null || _this$_sessionDetails27 === void 0 ? void 0 : (_this$_sessionDetails28 = _this$_sessionDetails27.deliveryServiceDateTime) === null || _this$_sessionDetails28 === void 0 ? void 0 : _this$_sessionDetails28.actualDeliveryDateTime).isSameOrBefore(restLocalDateTime.format(DATE_CONSIDERATIONS.DATE_TIME_FORMAT_WITH_SLASH)) && ((_this$_sessionDetails29 = this._sessionDetails) === null || _this$_sessionDetails29 === void 0 ? void 0 : (_this$_sessionDetails30 = _this$_sessionDetails29.orderContext) === null || _this$_sessionDetails30 === void 0 ? void 0 : _this$_sessionDetails30.orderTypeValue) === 2) {
          return false;
        }
      }

      return true;
    }
  }, {
    key: "validPickupTime",
    get: function get() {
      var _this$_sessionDetails31, _this$_sessionDetails32, _this$_sessionDetails33, _this$_sessionDetails34, _this$_sessionDetails35;

      var orderTypeValue = (_this$_sessionDetails31 = this._sessionDetails) === null || _this$_sessionDetails31 === void 0 ? void 0 : (_this$_sessionDetails32 = _this$_sessionDetails31.orderContext) === null || _this$_sessionDetails32 === void 0 ? void 0 : _this$_sessionDetails32.orderTypeValue;
      var restDetailsRestObj = (_this$_sessionDetails33 = this._sessionDetails) === null || _this$_sessionDetails33 === void 0 ? void 0 : _this$_sessionDetails33.restaurantDetails;
      var restLocalDateTime = getAdjustedRestaurantLocalTime(restDetailsRestObj === null || restDetailsRestObj === void 0 ? void 0 : restDetailsRestObj.timeZone, restDetailsRestObj === null || restDetailsRestObj === void 0 ? void 0 : restDetailsRestObj.dayLightSavingTime);

      if (moment((_this$_sessionDetails34 = this._sessionDetails) === null || _this$_sessionDetails34 === void 0 ? void 0 : (_this$_sessionDetails35 = _this$_sessionDetails34.orderContext) === null || _this$_sessionDetails35 === void 0 ? void 0 : _this$_sessionDetails35.actualPickupDateTime).isSameOrBefore(restLocalDateTime.format(DATE_CONSIDERATIONS.DATE_TIME_FORMAT_WITH_SLASH)) && (orderTypeValue === ORDER_TYPE.CATERING_PICKUP || orderTypeValue === ORDER_TYPE.TOGO_PICKUP)) {
        return false;
      }

      return true;
    }
  }, {
    key: "localdateTimeSelection",
    get: function get() {
      return this._localdateTimeSelection;
    }
  }, {
    key: "isTOGODeliveryCapacityError",
    get: function get() {
      return this._isTOGODeliveryCapacityError;
    }
  }, {
    key: "dateTimeAtRestaurantLocationTimezone",
    get: function get() {
      var _this$_sessionDetails36, _this$_sessionDetails37, _this$_sessionDetails38, _this$_sessionDetails39;

      return getAdjustedRestaurantLocalTime((_this$_sessionDetails36 = this._sessionDetails) === null || _this$_sessionDetails36 === void 0 ? void 0 : (_this$_sessionDetails37 = _this$_sessionDetails36.restaurantDetails) === null || _this$_sessionDetails37 === void 0 ? void 0 : _this$_sessionDetails37.timeZone, (_this$_sessionDetails38 = this._sessionDetails) === null || _this$_sessionDetails38 === void 0 ? void 0 : (_this$_sessionDetails39 = _this$_sessionDetails38.restaurantDetails) === null || _this$_sessionDetails39 === void 0 ? void 0 : _this$_sessionDetails39.dayLightSavingTime);
    }
  }, {
    key: "deliveryDateForPickupSwitch",
    get: function get() {
      var _this$_setPickupTimeR8, _this$_sessionDetails40, _this$_sessionDetails41, _this$_sessionDetails42; // if there is time from pickup time call use that (as SessionDetails is not called after pickuptime)


      if (this !== null && this !== void 0 && (_this$_setPickupTimeR8 = this._setPickupTimeResponse) !== null && _this$_setPickupTimeR8 !== void 0 && _this$_setPickupTimeR8.actualPickupDateTime) {
        var _this$_setPickupTimeR9;

        return moment(this === null || this === void 0 ? void 0 : (_this$_setPickupTimeR9 = this._setPickupTimeResponse) === null || _this$_setPickupTimeR9 === void 0 ? void 0 : _this$_setPickupTimeR9.actualPickupDateTime);
      } // else use time from session


      var deliveryDate = (_this$_sessionDetails40 = this._sessionDetails) === null || _this$_sessionDetails40 === void 0 ? void 0 : (_this$_sessionDetails41 = _this$_sessionDetails40.deliveryGroup) === null || _this$_sessionDetails41 === void 0 ? void 0 : (_this$_sessionDetails42 = _this$_sessionDetails41.deliveryServiceDateTime) === null || _this$_sessionDetails42 === void 0 ? void 0 : _this$_sessionDetails42.actualDeliveryDateTime; // If valid delivery date time is present, use that date, else default to current date
      // The delivery date present, should not be in past

      return deliveryDate && this.isValidDeliveryDate ? moment(deliveryDate) : moment();
    }
  }, {
    key: "canCheckoutWithTodaysDate",
    get: function get() {
      return this._canCheckoutWithTodaysDate;
    }
  }]);

  return TimeModel;
}(), (_descriptor = _applyDecoratedDescriptor(_class.prototype, "_appAttributes", [observable], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor2 = _applyDecoratedDescriptor(_class.prototype, "_capacitySlotsResponse", [observable], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor3 = _applyDecoratedDescriptor(_class.prototype, "_sessionDetails", [observable], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor4 = _applyDecoratedDescriptor(_class.prototype, "_setPickupTimeResponse", [observable], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor5 = _applyDecoratedDescriptor(_class.prototype, "_isTimeModalShown", [observable], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor6 = _applyDecoratedDescriptor(_class.prototype, "_selectedCalendarDate", [observable], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor7 = _applyDecoratedDescriptor(_class.prototype, "_isAsapOptionSelected", [observable], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor8 = _applyDecoratedDescriptor(_class.prototype, "_selectedTimeSlot", [observable], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor9 = _applyDecoratedDescriptor(_class.prototype, "_selectedTimeSlotFromDD", [observable], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor10 = _applyDecoratedDescriptor(_class.prototype, "_errorMessage", [observable], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor11 = _applyDecoratedDescriptor(_class.prototype, "_isCapacityError", [observable], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor12 = _applyDecoratedDescriptor(_class.prototype, "_datePickerRef", [observable], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor13 = _applyDecoratedDescriptor(_class.prototype, "_timePickerRef", [observable], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor14 = _applyDecoratedDescriptor(_class.prototype, "_timeUpdatedModalAcknowledged", [observable], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor15 = _applyDecoratedDescriptor(_class.prototype, "_datePickerIsOpen", [observable], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor16 = _applyDecoratedDescriptor(_class.prototype, "_cartLeadTime", [observable], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor17 = _applyDecoratedDescriptor(_class.prototype, "_recentTimeSelectionFromAPI", [observable], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor18 = _applyDecoratedDescriptor(_class.prototype, "_currentRequestedDate", [observable], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor19 = _applyDecoratedDescriptor(_class.prototype, "_fetchTimeOrderType", [observable], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor20 = _applyDecoratedDescriptor(_class.prototype, "_orderID", [observable], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: function initializer() {
    return null;
  }
}), _descriptor21 = _applyDecoratedDescriptor(_class.prototype, "_localdateTimeSelection", [observable], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: function initializer() {
    return null;
  }
}), _descriptor22 = _applyDecoratedDescriptor(_class.prototype, "_isTOGODeliveryCapacityError", [observable], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor23 = _applyDecoratedDescriptor(_class.prototype, "_canCheckoutWithTodaysDate", [observable], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _applyDecoratedDescriptor(_class.prototype, "fetchTimeOrderType", [computed], Object.getOwnPropertyDescriptor(_class.prototype, "fetchTimeOrderType"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "recentTimeSelectionFromAPI", [computed], Object.getOwnPropertyDescriptor(_class.prototype, "recentTimeSelectionFromAPI"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "datePickerIsOpen", [computed], Object.getOwnPropertyDescriptor(_class.prototype, "datePickerIsOpen"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "datePickerRef", [computed], Object.getOwnPropertyDescriptor(_class.prototype, "datePickerRef"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "timePickerRef", [computed], Object.getOwnPropertyDescriptor(_class.prototype, "timePickerRef"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "isValid", [computed], Object.getOwnPropertyDescriptor(_class.prototype, "isValid"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "capacitySlotsResponse", [computed], Object.getOwnPropertyDescriptor(_class.prototype, "capacitySlotsResponse"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "isTimeModalShown", [computed], Object.getOwnPropertyDescriptor(_class.prototype, "isTimeModalShown"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "isSelectedDateDayOfPickup", [computed], Object.getOwnPropertyDescriptor(_class.prototype, "isSelectedDateDayOfPickup"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "shouldShowAutomaticTimeUpdateMessage", [computed], Object.getOwnPropertyDescriptor(_class.prototype, "shouldShowAutomaticTimeUpdateMessage"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "isAsapOptionSelected", [computed], Object.getOwnPropertyDescriptor(_class.prototype, "isAsapOptionSelected"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "isAsapSelectedFromAPI", [computed], Object.getOwnPropertyDescriptor(_class.prototype, "isAsapSelectedFromAPI"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "isAsapSelected", [computed], Object.getOwnPropertyDescriptor(_class.prototype, "isAsapSelected"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "needMoreCookTime", [computed], Object.getOwnPropertyDescriptor(_class.prototype, "needMoreCookTime"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "selectedCalendarDate", [computed], Object.getOwnPropertyDescriptor(_class.prototype, "selectedCalendarDate"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "areSlotsAvailable", [computed], Object.getOwnPropertyDescriptor(_class.prototype, "areSlotsAvailable"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "currentTimeSlot", [computed], Object.getOwnPropertyDescriptor(_class.prototype, "currentTimeSlot"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "currentAPITimeSlot", [computed], Object.getOwnPropertyDescriptor(_class.prototype, "currentAPITimeSlot"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "restaurantLocalTime", [computed], Object.getOwnPropertyDescriptor(_class.prototype, "restaurantLocalTime"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "selectedTimeSlot", [computed], Object.getOwnPropertyDescriptor(_class.prototype, "selectedTimeSlot"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "selectedTimeSlotFromDD", [computed], Object.getOwnPropertyDescriptor(_class.prototype, "selectedTimeSlotFromDD"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "errorMessage", [computed], Object.getOwnPropertyDescriptor(_class.prototype, "errorMessage"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "selectedTimeOnPageLoad", [computed], Object.getOwnPropertyDescriptor(_class.prototype, "selectedTimeOnPageLoad"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "isCapacityError", [computed], Object.getOwnPropertyDescriptor(_class.prototype, "isCapacityError"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "timeUpdatedModalAcknowledged", [computed], Object.getOwnPropertyDescriptor(_class.prototype, "timeUpdatedModalAcknowledged"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "currentAPIPickupTime", [computed], Object.getOwnPropertyDescriptor(_class.prototype, "currentAPIPickupTime"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "displayDate", [computed], Object.getOwnPropertyDescriptor(_class.prototype, "displayDate"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "doesApiPickupTimeHasSlot", [computed], Object.getOwnPropertyDescriptor(_class.prototype, "doesApiPickupTimeHasSlot"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "isASAPSelected", [computed], Object.getOwnPropertyDescriptor(_class.prototype, "isASAPSelected"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "asapTextForModalOption", [computed], Object.getOwnPropertyDescriptor(_class.prototype, "asapTextForModalOption"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "calendarDisplayDate", [computed], Object.getOwnPropertyDescriptor(_class.prototype, "calendarDisplayDate"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "isAsapCutOffReached", [computed], Object.getOwnPropertyDescriptor(_class.prototype, "isAsapCutOffReached"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "asapCutoffTime", [computed], Object.getOwnPropertyDescriptor(_class.prototype, "asapCutoffTime"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "_effectiveLeadTime", [computed], Object.getOwnPropertyDescriptor(_class.prototype, "_effectiveLeadTime"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "_apiLeadTime", [computed], Object.getOwnPropertyDescriptor(_class.prototype, "_apiLeadTime"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "_leadTimeCapSlot", [computed], Object.getOwnPropertyDescriptor(_class.prototype, "_leadTimeCapSlot"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "onTimeSlotSelection", [action], Object.getOwnPropertyDescriptor(_class.prototype, "onTimeSlotSelection"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "selectedCalendarTime", [computed], Object.getOwnPropertyDescriptor(_class.prototype, "selectedCalendarTime"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "isRestaurantClosedToday", [computed], Object.getOwnPropertyDescriptor(_class.prototype, "isRestaurantClosedToday"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "isAsapEnabled", [computed], Object.getOwnPropertyDescriptor(_class.prototype, "isAsapEnabled"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "isASapEnabledAPI", [computed], Object.getOwnPropertyDescriptor(_class.prototype, "isASapEnabledAPI"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "availableSlots", [computed], Object.getOwnPropertyDescriptor(_class.prototype, "availableSlots"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "_sortedSlots", [computed], Object.getOwnPropertyDescriptor(_class.prototype, "_sortedSlots"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "isDeliveryOrder", [computed], Object.getOwnPropertyDescriptor(_class.prototype, "isDeliveryOrder"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "isDineInOrder", [computed], Object.getOwnPropertyDescriptor(_class.prototype, "isDineInOrder"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "maxFutureDate", [computed], Object.getOwnPropertyDescriptor(_class.prototype, "maxFutureDate"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "calendarConfig", [computed], Object.getOwnPropertyDescriptor(_class.prototype, "calendarConfig"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "calendarDates", [computed], Object.getOwnPropertyDescriptor(_class.prototype, "calendarDates"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "isSelectedTimeSlotValid", [computed], Object.getOwnPropertyDescriptor(_class.prototype, "isSelectedTimeSlotValid"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "firstAvailableSlot", [computed], Object.getOwnPropertyDescriptor(_class.prototype, "firstAvailableSlot"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "isFreshSession", [computed], Object.getOwnPropertyDescriptor(_class.prototype, "isFreshSession"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "doesCartHaveItemWithNoPickupTime", [computed], Object.getOwnPropertyDescriptor(_class.prototype, "doesCartHaveItemWithNoPickupTime"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "restaurantHolidays", [computed], Object.getOwnPropertyDescriptor(_class.prototype, "restaurantHolidays"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "isValidDeliveryDate", [computed], Object.getOwnPropertyDescriptor(_class.prototype, "isValidDeliveryDate"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "validPickupTime", [computed], Object.getOwnPropertyDescriptor(_class.prototype, "validPickupTime"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "localdateTimeSelection", [computed], Object.getOwnPropertyDescriptor(_class.prototype, "localdateTimeSelection"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "setIsTOGODeliveryCapacityError", [action], Object.getOwnPropertyDescriptor(_class.prototype, "setIsTOGODeliveryCapacityError"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "dateTimeAtRestaurantLocationTimezone", [computed], Object.getOwnPropertyDescriptor(_class.prototype, "dateTimeAtRestaurantLocationTimezone"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "deliveryDateForPickupSwitch", [computed], Object.getOwnPropertyDescriptor(_class.prototype, "deliveryDateForPickupSwitch"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "setCanCheckoutWithTodaysDate", [action], Object.getOwnPropertyDescriptor(_class.prototype, "setCanCheckoutWithTodaysDate"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "canCheckoutWithTodaysDate", [computed], Object.getOwnPropertyDescriptor(_class.prototype, "canCheckoutWithTodaysDate"), _class.prototype)), _class);
export { TimeModel as default };